import type { GuideCommand } from "@asurion-core/expert-workspace-timeline";

import { Flex } from "@mantine/core";
import { useMemo } from "react";
import { withErrorBoundary } from "react-error-boundary";

import type { TrainingTask } from "@/sdk";

import { TrainingModal } from "@/components/training";
import styles from "@/components/workspace/workspace.module.css";
import { WorkspaceBody } from "@/components/workspace/WorkspaceBody";
import { ExpertUniversityHome } from "@/expert-university";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { createFallbackRender } from "@/shared-utils";

interface WorkspaceContentLeftTopASlotProps {
    showExpertUniversity: undefined | boolean;
    activeTrainingTask: TrainingTask | null;
    guideToolboxCommand: GuideCommand;
}

export function WorkspaceContentLeftTopASlot({
    showExpertUniversity,
    activeTrainingTask,
    guideToolboxCommand,
}: WorkspaceContentLeftTopASlotProps) {
    const logger = useLogger({ module: "Workspace" });

    const TrainingModalHandled = useMemo(
        () => withErrorBoundary(TrainingModal, { fallbackRender: createFallbackRender(logger) }),
        [logger],
    );

    return (
        <Flex pos={"absolute"} inset={0}>
            {showExpertUniversity ? (
                // If the conditions are met for Expert University, show the Training home page
                <ExpertUniversityHome />
            ) : activeTrainingTask?.startTimestamp ? (
                // This modal should not really be rendered here. It probably belongs in WorkspaceContent.tsx
                // After some research, we may be able to remove all of this. It was related to Mission Control.
                // We should ask Heather HartsogMoore, Alex Thomas, and Kiel Moulon about it to be sure.
                <Flex className={styles.workspaceBody} direction="row" m="2.5rem 3rem">
                    <TrainingModalHandled task={activeTrainingTask} />
                </Flex>
            ) : (
                <WorkspaceBody guideToolboxCommand={guideToolboxCommand} />
            )}
        </Flex>
    );
}
